import { CLIENT_CONTEXT_PREFIX } from "../settings/index.js";
export function encodeContext(context) {
  return Object.entries(context).reduce(
    (acc, [key, value]) => {
      if (typeof value === "string") {
        acc[CLIENT_CONTEXT_PREFIX + key] = value;
      }
      return acc;
    },
    {}
  );
}
